module.exports = __webpack_public_path__ + "img/FotoMo6.6a207826.png";